<template>
  <div class="wrap">
    <div class="shopItem flex" v-for="item in dataList" :key="item.shopId">
        <div class="shopBox mr-20"><ShopItem :platform="platform" :shopId="item.shopId" /></div>
        <el-button v-if="!item.modelList.length" icon="el-icon-plus" @click="choiceModel(item.shopId)">添加模特</el-button>
        <div v-else class="flex-1">
            <div class="modelBox flex space-between align-center" v-for="(model,index) in item.modelList" :key="model.modelId">
                <div class="flex align-center flex-1">
                    <el-avatar :src="model.modelProfileUrl" style="width:40px;"></el-avatar>
                    <div class="modelCon flex-1">
                        <div class="modelTitle">{{model.modelName}}</div>
                        <div>{{getModelInfoStr(model,item.shopId)}}</div>
                        <div>试穿尺码:{{model.sizeSpecName}}&nbsp;&nbsp;试穿感受:{{tryOnResultMap[model.tryOnResult]}}</div>
                    </div>
                </div>
                <div class="" style="width:160px;">
                    <el-button class="mr-10" @click="choiceModel(item.shopId,model.modelId)">更换</el-button>
                    <el-button @click="deleteModel(item.shopId,index)">删除</el-button>
                </div>
            </div>
        </div>
    </div>
    <div class="el-form-item__error" v-if="errorText">{{errorText}}</div>
    <el-dialog
        title="选择模特"
        :visible.sync="choiceDialogVisible"
        width="700px"
    >
        <div>
            <el-input placeholder="输入模特名称查询" v-model="searchWord">
                <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <div style="max-height:300px;overflow-y: scroll;">
                <div class="modelBox flex align-center mt-10" style="cursor: pointer;" v-for="item in filterList" :key="item.id" @click="editModel(item)">
                    <el-avatar :src="item.headPortrait"></el-avatar>
                    <div class="modelCon">
                        <div class="modelTitle">{{item.modelName}}</div>
                        <div>{{getModelInfoStr(item)}}</div>
                    </div>
                </div>
            </div>
            <div class="mt-10">无模特可选？<el-link :underline="false" @click="handleCreate">去创建模特</el-link></div>
        </div>
    </el-dialog>
    <el-dialog
        title="创建模特"
        :visible.sync="createDialogVisible"
        width="600px"
    >
        <div class="createWrap">
            <el-form :model="createForm" :rules="formRules" ref="formRef" label-width="100px">
                <el-form-item label="模特头像" prop="headPortrait">
                    <ImgUpload
                        ref="headPortraitRef"
                        :file="createForm.headPortrait"
                        v-bind="avatarLimits"
                        @upload-success="url => (createForm.headPortrait = url)"
                        @del="() => (createForm.headPortrait = '')"
                    />
                    <div class="tips">头像比例1:1，需≥480px，支持.jpg或.png</div>
                </el-form-item>
                <el-form-item label="模特名称" prop="modelName">
                    <el-input v-model="createForm.modelName" maxlength="30" show-word-limit></el-input>
                </el-form-item>
                <el-form-item v-for="(value, field) in modelTypeField" :label="modelTypeNameMap[field]" :prop="field" :key="field">
                    <InputDigitComb v-model="createForm[field]" suffixText="CM" @input="handleFieldInput(field)"></InputDigitComb>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="createDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="createModel">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog
        title="模特信息"
        :visible.sync="setDialogVisible"
        width="800px"
    >
        <div class="modelBox flex space-between align-center mb-10">
            <div class="flex align-center">
                <el-avatar :src="editData.headPortrait"></el-avatar>
                <div class="modelCon">
                    <div class="modelTitle">{{editData.modelName}}</div>
                    <div>{{getModelInfoStr(editData)}}</div>
                </div>
            </div>
            <div class="">
                <el-button class="mr-10" @click="choiceModel()">更换</el-button>
            </div>
        </div>
        <el-form :model="modelInfoForm" :rules="modelInfoRules" ref="modelInfoFormRef" label-width="75px" label-position="left">
            <el-form-item label="试穿尺码:" prop="sizeSpecId">
                <el-radio-group v-model="modelInfoForm.sizeSpecId">
                    <el-radio v-for="size in sizeOptions" :label="size.specId" :key="size.specId">{{size.label}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="试穿感受" prop="tryOnResult">
            <el-radio-group v-model="modelInfoForm.tryOnResult">
                <el-radio v-for="(value,key) in tryOnResultMap" :label="key" :key="key">{{value}}</el-radio>
            </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="setDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="modelInfoConfirm">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import ShopItem from '@/components/prod/ShopItem.vue'
import ImgUpload from '@/components/Uploads/ImgUpload';
import InputDigitComb from '@/components/prod/center/components/FormItemSpecification/components/InputDigitComb.vue'
import { cloneDeep } from 'lodash';
import { tryOnResultMap,modelTypeMap,modelTypeNameMap } from '../config.js'
import {getModelInfo,addModelInfo} from '@/servers/prod/center/temu.js'
export default {
    components:{
        ShopItem,
        ImgUpload,
        InputDigitComb,
    },
    props:{
        platform:{
            type:String,
            default:''
        },
        value:{
            type:Array,
            default:() => []
        },
        categoryId:{
            type:String,
            default:''
        },
        shopList:{
            type:Array,
            default:() => []
        },
        specifications:{
            type:Array,
            default:() => []
        },
        enabledModelType:{ // 模特类型
            type:Number,
            default:0,
        },
    },
    data(){
        return {
            tryOnResultMap,
            modelTypeMap,
            modelTypeNameMap,
            choiceDialogVisible:false, // 选择模特
            createDialogVisible:false, // 创建模特
            setDialogVisible:false, // 设置模特信息
            searchWord:'',
            dataList:[],
            createForm:{ // 创建模特表单数据
                modelName:'',
                headPortrait:''
            },
            modelInfoForm:{ // 模特信息表单数据
                sizeSpecId:'',
                tryOnResult:''
            },
            shopModelMap:{}, // 店铺维度缓存模特列表数据
            editShopId:'', // 当前编辑的店铺
            editModelId:'', // 当前要更换的模特id
            editData:{}, // 当前编辑的模特
            avatarLimits:{ // 创建模特-头像图片限制
                isSingle:true,
                limitSize: 2 * 1024 * 1024,
                limitWidth: [480, 0],
                limitHeight: [480, 0],
                aspectRatio: [1],
                aspectRatioText:"1:1"
            },
            modelInfoRules:{// 模特信息表单校验规则
                sizeSpecId:[
                    { required: true, message: '请选择试穿尺码', trigger: 'change' }
                ],
                tryOnResult:[
                    { required: true, message: '请选择试穿感受', trigger: 'change' }
                ],
            },
            errorText:''
        }
    },
    computed:{
        filterList(){
            return (this.shopModelMap[this.editShopId] || []).filter(i => i.modelName.indexOf(this.searchWord) != -1)
        },
        valueMap(){
            let map = {};
            ;(this.value || []).forEach(v => {
                let shopId = v.shopId
                map[shopId] = v
            });
            return map
        },
        // 规格名
        specificationNames() {
            let list = (this.specifications || []).filter(Boolean).map((item) => ({ name: item.name, checked: !!(item.checked || item.checked === undefined) }));
            return list
        },
        sizeOptions(){
            let sizeObj = this.specifications.find(item => item.name === '尺码')
            let list = []
            if(sizeObj){
                list = (sizeObj.values || []).map(i => ({
                    specId:i?.extendValues?.specId || '',
                    label:i.value
                }))
            }
            return list
        },
        // 对应模特类型的字段
        modelTypeField(){
            return this.modelTypeMap[this.enabledModelType] || {}
        },
        // 动态生成创建表单校验规则（除头像外全部必填）
        formRules() {
            const rules = {
                modelName: { required: true, message: '请输入模特名称', trigger: 'change' },
            };
            // 动态字段不设trigger（自定义组件的$emit不会冒泡为原生DOM事件），依赖提交时validate校验
            for (let field in this.modelTypeField) {
                const label = this.modelTypeNameMap[field] || '';
                rules[field] = { required: true, message: `请输入${label}` };
            }
            return rules;
        },
    },
    watch:{
        shopList:{
            handler(v){
                this.init()
            },
            immediate:true,
            deep:true
        },
        value:{
            handler(v){
                this.init()
            },
            immediate:false,
            deep:true
        },
        modelTypeField:{
            handler(v){
                for(let k in v){
                    this.$set(this.createForm, k, '')
                }
            },
            immediate:true,
            deep:false
        }
    },
    methods:{
        init(){
            let list = []
            let _shopModelMap = {...this.shopModelMap}
            this.shopList.forEach(shop => {
                let shopId = shop.id
                let data = this.valueMap[shopId] || {}
                let obj = {
                    modelList:data.modelList || [],
                    shopId:shopId,
                }
                _shopModelMap[shopId] = _shopModelMap[shopId] || []; // 初始化模特列表数据
                list.push(obj)
            });
            this.dataList = list
            this.shopModelMap = _shopModelMap
        },
        valid(){
            return new Promise(resolve => {
                let hasError = false
                this.dataList.forEach(item => {
                    const { shopId,modelList } = item
                    let valList = modelList.filter(i => i.modelId);
                    if(valList.length === 0){
                        hasError = true
                    }
                });
                if(hasError){
                    this.errorText = '请设置模特!'
                    resolve(false)
                }else{
                    this.errorText = ''
                    resolve(true)
                }
            });
        },
        getData(){
            let list = []
            list = this.dataList.map(item => {
                const { shopId,modelList } = item
                let newmMdelList = modelList.map(m => {
                    const { modelProfileUrl,sizeSpecName,modelId,sizeSpecId,modelName,tryOnResult,clothesModel,shoeModel,modelType } = m
                    let o = {
                        modelProfileUrl,
                        sizeSpecName,
                        modelId,
                        sizeSpecId,
                        modelName,
                        tryOnResult,
                        modelType,
                    }
                    if(clothesModel){
                        o.clothesModel = clothesModel
                    }
                    if(shoeModel){
                        o.shoeModel = shoeModel
                    }
                    return o
                });
                let obj = {
                    shopId,
                    modelList:newmMdelList
                }
                return obj
            });
            return list
        },
        // 获取模特数据
        getModelList(isUpdate){
            const shopId = this.editShopId
            let params = {
                shopId,
                catId:this.categoryId,
                modelType:this.enabledModelType, // 模特类型：0-成衣模特，1-鞋模
                pageNo:1,
                pageSize:200,
                modelName:''
            }
            if(!isUpdate && this.shopModelMap[shopId] && this.shopModelMap[shopId].length){
                return 
            }
            getModelInfo(params).then(res => {
                if(res){
                    this.$set(this.shopModelMap,shopId,res.modelList || [])
                }
            })
        },
        // 添加/更改模特
        choiceModel(shopId,editModelId){
            if(shopId){
                this.editShopId = shopId
            }
            this.editModelId = editModelId || null
    
            this.searchWord = ''
            this.createDialogVisible = false
            this.setDialogVisible = false
            this.choiceDialogVisible = true
            this.getModelList();
        },
        //点击创建模特
        handleCreate(){
            this.createDialogVisible = true
            this.$nextTick(() => {
                this.$refs.formRef?.resetFields()
            })
        },
        //创建模特
        createModel(){
            this.$refs.formRef.validate(valid => {
                if(!valid) return;
                let { modelName,headPortrait,...reset } = this.createForm
                let params = {
                    shopId:this.editShopId,
                    modelName,
                    headPortrait,
                    modelType:this.enabledModelType, // 模特类型：0-成衣模特，1-鞋模
                }
                if(params.modelType == 0){ // 成衣模特
                    params.clothesModel = {...reset}
                }else if(params.modelType == 1){ // 鞋模
                    params.shoeModel = {...reset}
                }
                addModelInfo(params).then(res => {
                    if(res){
                        this.getModelList(true);
                        this.createDialogVisible = false
                        this.$message.success('创建成功！')
                    }
                })
            })
        },
        // 选择的模特
        editModel(data){
            this.setDialogVisible = true
            this.editData = data
            this.$nextTick(() => {
                this.$refs.modelInfoFormRef?.resetFields()
            })
        },
        // 点击修改模特弹窗-确定按钮
        modelInfoConfirm(){
            this.$refs.modelInfoFormRef.validate(valid => {
                if(!valid){
                    this.$message.warning('请完善数据！')
                    return false
                }
                const {modelName,id,headPortrait,clothesModel,shoeModel,modelType} = this.editData // 模特数据
                const {sizeSpecId,tryOnResult} = this.modelInfoForm // 试穿尺码、试穿感受
                let sizeSpecObj = this.sizeOptions.find(s => s.specId === sizeSpecId) || {}; // 规格名称
                let result = {
                    modelType,
                    modelProfileUrl:headPortrait,
                    sizeSpecName:sizeSpecObj.label,
                    modelId:id,
                    sizeSpecId,
                    modelName,
                    tryOnResult:tryOnResult,
                    clothesModel,
                    shoeModel,
                }
                // 整理修改修改的数据
                let shopId = this.editShopId
                let editModelId = this.editModelId;
                let rowIndex = this.dataList.findIndex(i => i.shopId == shopId);
                let row = this.dataList[rowIndex]
                let newDataObj = cloneDeep(result)
                if(row){
                    let newList = (row.modelList || []).filter(i => i.modelId)
                    let index = newList.findIndex(i => i.modelId === editModelId)
                    if(index != -1){
                        newList.splice(index, 1, newDataObj)
                    }else{
                        newList.push(newDataObj)
                    }
                    this.$set(this.dataList[rowIndex],'modelList',newList)
                }
                this.setDialogVisible = false;
                this.choiceDialogVisible = false;
            })
        },
        // 删除
        deleteModel(shopId,index){
            let rowIndex = this.dataList.findIndex(i => i.shopId == shopId);
            let row = this.dataList[rowIndex]
            if(row){
                row.modelList.splice(index, 1)
            }
        },
        handleFieldInput(field) {
            // 自定义组件不触发原生DOM事件，手动触发校验
            this.$refs.formRef?.validateField(field);
        },
        getModelInfoStr(data,shopId){
            let _shopid = shopId || this.editShopId
            let obj = {}
            if(typeof data === 'string' || typeof data === 'number'){
                obj = this.shopModelMap[_shopid].find(item => item.id == data) || {}
            }else{
                obj= data.modelType === 0 ? data.clothesModel : data.shoeModel
            }
            let arr = []
            for(let k in obj){
                arr.push(this.modelTypeNameMap[k] + ':'+obj[k])
            }
            return arr.join('  ')
        }
    },
}
</script>

<style lang="scss" scoped>
.wrap{
    .shopBox{
        max-width: 300px;
    }
    .shopItem{
        padding: 10px 12px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        background: #fafbfc;
        margin-bottom: 8px;
    }
}
.modelBox{
    padding: 10px 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fff;
}
.modelCon{
    font-size: 12px;
    color: #606266;
    margin-left: 20px;
    .modelTitle{
        color: #303133;
        font-weight: 500;
    }
}
.tips{
    font-size: 12px;
    color: #909399;
}
</style>